import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  type?: 'website' | 'article';
  url?: string;
  image?: string;
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  keywords?: string[];
  noIndex?: boolean;
}

export default function SEO({
  title,
  description,
  type = 'website',
  url = 'https://www.greyfielddata.com',
  image = 'https://www.greyfielddata.com/dashboard.jpg',
  publishedTime,
  modifiedTime,
  author = 'Linus Tse',
  keywords = [],
  noIndex = false,
}: SEOProps) {
  const fullTitle = title.includes('Greyfield') ? title : `${title} | Greyfield Data`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Greyfield Data" />

      {/* Article specific */}
      {type === 'article' && (
        <>
          {publishedTime && <meta property="article:published_time" content={publishedTime} />}
          {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
          <meta property="article:author" content={author} />
          <meta property="article:section" content="Technology" />
        </>
      )}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@linustse" />

      {/* Additional SEO */}
      <meta name="robots" content={noIndex ? 'noindex, follow' : 'index, follow'} />
      <meta name="googlebot" content={noIndex ? 'noindex, follow' : 'index, follow'} />
    </Helmet>
  );
}
